import { TrackerStepStatus } from 'src/types';

export const colorByTrackerStepStatus: Record<TrackerStepStatus, string> = {
	completed: '#1aba22',
	error: '#f0292c',
	inProgress: 'gray',
	notStarted: 'gray',
	pending: 'gray',
};
